export default __webpack_public_path__ + "static/media/standoff.92c0c4ed.jpg";